import React from "react";
import { useClassPrepend } from "../../../../hook/ui/common/className/useClassPrepend";
import { useChildrenProps } from "../../../../hook/ui/common/children/useChildrenProps";

/*
    Wraps the Table Body to show a message below the body when there are no rows

    props
        (jsx, optional)  noDataMessage  The content to show when there are no rows
*/

const UnstyledTableBodyNoDataWrapper = ({
  classPrepend = "unstyled",
  noDataMessage = "No data available",
  rows = [],
  children,
  ...rest
}) => {
  const [getClassName, getClassNameWithGlobal] = useClassPrepend(classPrepend);
  const [childrenWithProps] = useChildrenProps(children, {
    classPrepend,
    rows,
    ...rest
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, childrenWithProps, !rows || rows?.length === 0 && /*#__PURE__*/React.createElement("div", getClassName("table-no-data-message-container"), noDataMessage));
};
export { UnstyledTableBodyNoDataWrapper };